import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../services/api';

const VerifyEmail = () => {
    const [message, setMessage] = useState('Overujem Váš účet...');
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const token = queryParams.get('token');

        if (token) {
            api.get(`/auth/verify?token=${token}`)
                .then(response => {
                    // On success, backend now sends a success message.
                    // We handle the redirect here on the frontend.
                    navigate('/login?verified=true');
                })
                .catch(error => {
                    const resMessage =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                    setMessage(`Chyba pri overovaní: ${resMessage}. Skúste to znova alebo kontaktujte podporu.`);
                });
        } else {
            setMessage('Chýba overovací token.');
        }
    }, [location, navigate]);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
            <h2>Effzone</h2>
            <p>{message}</p>
        </div>
    );
};

export default VerifyEmail; 